import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { VendorLookup } from 'shared/types';

export function useSelectFormVendor(index?: number) {
  const { setValue } = useFormContext();

  const updateField = useCallback(
    (field: `${string}`, value: any) => {
      const prefix = `products.${index}`;
      const key = `${prefix}.${field}` as const;
      setValue(index !== undefined ? key : field, value);
    },
    [index, setValue]
  );
  const onChange = useCallback(
    (product: string | Record<keyof VendorLookup, string> | null) => {
      if (typeof product === 'string') {
      } else if (product && product.inputValue) {
        // This is a new vendor
        updateField('vendorName', product?.inputValue || '');
        updateField('vendorId', product?.vendorid || '');
        updateField('newVendor', true);
      } else {
        updateField('vendorName', product?.vendorname || '');
        updateField('vendorId', product?.vendorid || '');
        updateField('newVendor', false);
      }
    },
    [updateField]
  );
  const onClear = useCallback(() => {
    updateField('vendorId', '');
    updateField('newVendor', false);
  }, [updateField]);

  return [onChange, onClear] as const;
}
